import { createContext } from 'react'

import initValue from './initValue'

const RMAContext = createContext({
  rmaInfo: initValue,
  setRmaInfo: () => {},
})

export default RMAContext
